import { Component, OnInit, AfterViewInit } from "@angular/core";
import { CclNavbarFooterService, CclMessageService, CclDrawerService, CclRouteTab } from "certain-common-library";
import { SharedService } from "../../../../../modules/shared/services/shared.service";
import { CatalogService } from "../../../../../modules/shared/services/catalog.service";
import { SessionWidgetService } from "../../../../../modules/shared/services/session-widget.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { Subscription } from "rxjs";
import { cloneDeep } from "lodash";
import { UnsavedChangesDeactivate } from "../../../can-deactivate";

@Component({
    selector: "app-recommendation-widget-page",
    templateUrl: "./recommendation-widget-page.view.html",
    styleUrls: []
})
export class RecommendationWidgetPageView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit {
    subscription: Subscription;
    baseUrl: string;
    sessionWidgetConfigObj: any;
    sessionWidgetConfig: any = {};
    widgets: any = [];
    widgetSnippet: any = [];
    selectedWidget: any = {};
    catalogLayoutConfig: any = {};
    widgetCatalogConfiguredCssStyle: string;
    isWidgetScrollable = false;
    widetPlacementComponents: any = [];
    headerConfig: any = {};
    htmlTopConfig: any = {};

    // Widgets configuration default colors
    widgetBackgroundColor = 'white';
    widgetTitleTextColor = 'black';
    widgetTitleBackgroundColor = '#f3f3f3';
    widgetButtonTextColor = 'black';
    widgetButtonBackgroundColor = 'grey';
    widgetItemBackgroundColor = 'white';
    carouselArrowBoxColor = 'black  ';    
    carouselArrowColor = 'white';
    carouselDotsColor = 'black';
    carouselDotsInactiveColor = 'red';

    constructor(
        public sharedService: SharedService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private _flashMessagesService: FlashMessagesService,
        private catalogService: CatalogService,
        private drawerService: CclDrawerService,
        private sessionWidgetService: SessionWidgetService
    ) {
        super(sharedService);
        this.baseUrl = "sessionrecommendationwidgets";

        this.subscription = this.messageService.getMessage().subscribe((message) => this.savesessionWidgetConfig(message));
    }

    ngOnInit() {
        this.sharedService.currentLayoutSection = "sessionrecommendationwidget";
        this.sharedService.sessionUrl = this.baseUrl;
        this.drawerService.closeMessage = null;
        this.catalogLayoutConfig = JSON.parse(this.sharedService.setup.layoutConfig);
        this.sessionWidgetConfigObj = this.sharedService.configs[this.sharedService.configTypes.SESSION_RECOMMENDATION_WIDGET_CONFIG];
        
        this.headerConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.HEADER_FOOTER['header']].config);
        this.htmlTopConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.HTML['top']].config);
        if (this.sessionWidgetConfigObj == null || this.sessionWidgetConfigObj.id == null) {
            this.sessionWidgetConfig = cloneDeep(this.sharedService.sessionLayoutConfig[this.baseUrl]);
            this.sessionWidgetConfigObj = {
                id: null,
                setupId: this.sharedService.setup.id,
                sessionCatalogSetup: {
                    id: this.sharedService.setup.id
                },
                config: {
                    "isWidgetEnabled": false,
                    "widget": {
                        "uuid": "",
                        "applyCatalogConfiguration": false,
                        "configuration":null,
                        "themeConfiguration": null,
                        "text": null,
                        "widgetConfiguration": {
                            "color": null,
                            "theme": null,
                            "labels": null
                        },
                        "widgetPlacement": 'html',
                        "widgetPlacementPosition": 'bottom',
                        "widgetPlacementComponentPosition": {
                            "top": null,
                            "bottom": null
                        }
                    }
                },
                configType: this.sharedService.configTypes.SESSION_RECOMMENDATION_WIDGET_CONFIG
            };
        } else {
            this.sessionWidgetConfig = JSON.parse(this.sessionWidgetConfigObj.config);
            this.sharedService.sessionLayoutConfig[this.baseUrl] = cloneDeep(this.sessionWidgetConfig);
        }
        
        if (!this.sessionWidgetConfig.widget.hasOwnProperty("widgetPlacement") || !this.sessionWidgetConfig.widget.widgetPlacement) {
            this.sessionWidgetConfig.widget.widgetPlacement = "html";
        }

        if (!this.sessionWidgetConfig.widget.hasOwnProperty("widgetPlacementPosition") || !this.sessionWidgetConfig.widget.widgetPlacementPosition) {
            this.sessionWidgetConfig.widget.widgetPlacementPosition = "bottom";
        }

        if (!this.sessionWidgetConfig.widget.hasOwnProperty("widgetPlacementComponentPosition") || !this.sessionWidgetConfig.widget.widgetPlacementComponentPosition) {
            this.sessionWidgetConfig.widget.widgetPlacementComponentPosition = {
                "top": null,
                "bottom": null
            };
        }

        this.loadWidgetPlacementComponents(this.sessionWidgetConfig.widget.widgetPlacement, false);

        this.initLoadWidgetConfig();
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
            this.navbarFooterService.navbar.rightNavbarItems[0].label = "NEXT STEP: Define Data for Highlighted section";
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-sessionwidgets";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-sessionwidgets";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    ngOnDestroy(): void {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    initLoadWidgetConfig() {
        
        if (!this.sessionWidgetConfig.hasOwnProperty("isWidgetEnabled")) {
            this.sessionWidgetConfig.isWidgetEnabled = true;
        }

        if (!this.sessionWidgetConfig.widget.hasOwnProperty("configuration") || this.sessionWidgetConfig.widget.configuration == null) {
            this.sessionWidgetConfig.widget.configuration = {
                'widgetBackgroundColor': this.widgetBackgroundColor,//--widget-background-color
                'widgetTitleTextColor': this.widgetTitleTextColor, //--widget-title-text-color
                'widgetTitleBackgroundColor': this.widgetTitleBackgroundColor, //--widget-title-background-color
                'widgetButtonTextColor': this.widgetButtonTextColor, //--widget-button-text-color
                'widgetButtonBackgroundColor': this.widgetButtonBackgroundColor, //--widget-buttons-background-color
                'widgetItemBackgroundColor': this.widgetItemBackgroundColor, //--widget-item-background-color
                'carouselArrowBoxColor': this.carouselArrowBoxColor, // --carousel-arrow-box-color
                'carouselArrowColor': this.carouselArrowColor, //--carousel-arrow-color
                'carouselDotsColor': this.carouselDotsColor, //--carousel-dots-color
                'carouselDotsInactiveColor': this.carouselDotsInactiveColor //--carousel-dots-inactive-color
            };
        }
        
        if (!this.sessionWidgetConfig.widget.hasOwnProperty("themeConfiguration") || this.sessionWidgetConfig.widget.themeConfiguration == null) {
            this.sessionWidgetConfig.widget.themeConfiguration = {
                'theme': 'custom',
                'primary': '#D50000',
                'secondary': '#6A1B9A',
                'background': '#FFFFFF',
                'text': '#FFFFFF',
                'bodyText': '#000000'
            };
        }

        if (!this.sessionWidgetConfig.widget.hasOwnProperty("text") || this.sessionWidgetConfig.widget.text == null) {
            this.sessionWidgetConfig.widget.text = {
                'title': 'Recommendation for you',
                'addToSchedule': 'Add to Schedule',
                'similarSessions': 'Similar sessions',
                'recommendationDetails': 'Session Details',
                'recommendationsToReview': 'You have new recommendations to review.',
                'recommendationsToReviewClick': 'Click here to see them.',
		        'replaceSchedule': 'Replace Schedule',
		        'overlapSchedule': 'Replace Schedule',
		        'waitlistSchedule': 'Join Waitlist',
                'popularSearchLabel': 'Popular Search:',
                'similarSessionsButton': 'Similar sessions',
                'similarSessionsTitle': "Sessions similar to [title]",
                'confirmButton': 'Confirm',
                'cancelButton': 'Cancel',
                'myScheduleButton': 'My Schedule',
                'myScheduleTitle': 'Conference Schedule',
                'myScheduleSubTitle': 'Manage your personalized conference schedule',
                'myScheduleColumn': 'My Schedule',
                'myScheduleRecommendationColumn': 'Recommendations',
                'myScheduleFillTheDayButton': 'Fill the Day',
                'myScheduleAvailableSessionsTitle': 'Available Sessions',
            };
        }

        if (!this.sessionWidgetConfig.widget.hasOwnProperty("widgetConfiguration") || this.sessionWidgetConfig.widget.widgetConfiguration == null){
            this.sessionWidgetConfig.widget.widgetConfiguration = {
                "color": null,
                "theme": null,
                "labels": null
            };
        }

        this.prepareWidgetCatalogConfigurationStyle();
        // For checking unsaved data
        this.sharedService.originalData = cloneDeep(this.sessionWidgetConfig);
        this.sharedService.changedData = this.sessionWidgetConfig;
        this.loadWidgetsData();
    }

    loadWidgetsData() {
        if(this.sessionWidgetConfig.isWidgetEnabled && this.sharedService.enableSessionWidgets) {
            this.sessionWidgetService.getRecommendationWidgetsByUUID(this.sharedService.eventUUID).subscribe((resp) => {
                this.widgets = resp.body;
                this.changeWidgets(this.sessionWidgetConfig.widget.uuid);
            });
        } else {
            this.widgets = [];
            this.changeWidgets(this.sessionWidgetConfig.widget.uuid);
        }
    }
    
    prepareWidgetCatalogConfigurationStyle() {
        this.widgetCatalogConfiguredCssStyle = this.generateCatalogConfiguredWidgetCSS(this.sessionWidgetConfig.widget.configuration);
    }

    generateCatalogConfiguredWidgetCSS = (themeConfig): string => {

        return `
            .cRecommendation-widget-customization {
                --widget-background-color: ${themeConfig.widgetBackgroundColor};
                --widget-title-text-color: ${themeConfig.widgetTitleTextColor};
                --widget-title-background-color: ${themeConfig.widgetTitleBackgroundColor};
                --widget-button-text-color: ${themeConfig.widgetButtonTextColor};
                --widget-buttons-background-color: ${themeConfig.widgetButtonBackgroundColor};
                --widget-item-background-color: ${themeConfig.widgetItemBackgroundColor};
                --carousel-arrow-box-color: ${themeConfig.carouselArrowBoxColor};
                --carousel-arrow-color: ${themeConfig.carouselArrowColor};
                --carousel-dots-color: ${themeConfig.carouselDotsColor};
                --carousel-dots-inactive-color: ${themeConfig.carouselDotsInactiveColor};
            }
        `;
    };

    savesessionWidgetConfig(message) {
        if (message.text == "save-sessionwidgets" || message.text == "save-next-sessionwidgets") {

            const wPlacementPosition = this.sessionWidgetConfig.widget.widgetPlacementPosition;

            if(wPlacementPosition != 'nth_component') {
                this.sessionWidgetConfig.widget.widgetPlacementComponentPosition.top = null;
            } 

            if(wPlacementPosition != 'nth_component_bottom') {
                this.sessionWidgetConfig.widget.widgetPlacementComponentPosition.bottom = null;
            }

            if(wPlacementPosition == 'nth_component' || wPlacementPosition == 'nth_component_bottom') {
                let warningMessage = null;
                if((wPlacementPosition == 'nth_component' && !this.sessionWidgetConfig.widget.widgetPlacementComponentPosition.top) || (wPlacementPosition == 'nth_component_bottom' && !this.sessionWidgetConfig.widget.widgetPlacementComponentPosition.bottom)) {
                    warningMessage = 'Please select a position from the dropdown to display the widget.';
                }

                if(warningMessage && warningMessage.length > 0) {
                    this._flashMessagesService.show(warningMessage, {
                        cssClass: "alert-danger"
                    });

                    setTimeout(() => {
                       const componentDiv = document.getElementById(wPlacementPosition == 'nth_component' ? 'placementComponentTop' : 'placementComponentBottom');
                        if (componentDiv) {
                            setTimeout(() => {
                              const el = componentDiv.querySelector('input, select, textarea, button');
                              if (el) (el as HTMLElement).focus();
                            }, 100);
                          }
                      }, 100);
                    return;
                }
            }

            this.sessionWidgetConfigObj.config = JSON.stringify(this.sessionWidgetConfig);
            if(this.sessionWidgetConfigObj.setupId == undefined || this.sessionWidgetConfigObj.setupId == null ) {
                this.sessionWidgetConfigObj.setupId = this.sharedService.setup.id;
            }
            this.catalogService.saveSetupConfig(this.sessionWidgetConfigObj).subscribe((resp) => {
                // For checking unsaved data
                this.sharedService.createCss(this.catalogService);
                this.sharedService.originalData = cloneDeep(this.sessionWidgetConfig);
                this.sharedService.changedData = this.sessionWidgetConfig;

                this.sessionWidgetConfigObj = resp.body["sessionCatalogSetupConfigDTO"];
                
                this.sharedService.configs[this.sharedService.configTypes.SESSION_RECOMMENDATION_WIDGET_CONFIG] = this.sessionWidgetConfigObj;
                this._flashMessagesService.show("Session Advisor Widgets config saved successfully.", {
                    cssClass: "alert-success"
                });
                if (message.text == "save-next-sessionwidgets") {
                    this.sharedService.currentLayoutSection = "highlighted";
                    this.sharedService.catalogNavigateHelper("admin", "catalog/data/highlighted");
                }
            });

            // this._flashMessagesService.show("Session Advisor Widgets config saved successfully.", {
            //     cssClass: "alert-success"
            // });

            // if (message.text == "save-next-sessionwidgets") {
            //     this.sharedService.currentLayoutSection = "highlighted";
            //     this.sharedService.catalogNavigateHelper("admin", "catalog/data/highlighted");
            // }

        } else if (message.text == "apply-sessionwidgets-config") {
            this.sessionWidgetConfig = cloneDeep(this.sharedService.sessionLayoutConfig[this.baseUrl]);
            // For checking unsaved data
            this.sharedService.changedData = this.sessionWidgetConfig;

            //Apply Widget Catalog Configuration drawer configurations
            this.sessionWidgetConfig.widget.configuration.widgetBackgroundColor = this.sessionWidgetConfig.widget.configuration.widgetBackgroundColor;
            this.sessionWidgetConfig.widget.configuration.widgetTitleTextColor = this.sessionWidgetConfig.widget.configuration.widgetTitleTextColor;
            this.sessionWidgetConfig.widget.configuration.widgetTitleBackgroundColor = this.sessionWidgetConfig.widget.configuration.widgetTitleBackgroundColor;
            this.sessionWidgetConfig.widget.configuration.widgetButtonTextColor = this.sessionWidgetConfig.widget.configuration.widgetButtonTextColor;
            this.sessionWidgetConfig.widget.configuration.widgetButtonBackgroundColor = this.sessionWidgetConfig.widget.configuration.widgetButtonBackgroundColor;
            this.sessionWidgetConfig.widget.configuration.widgetItemBackgroundColor = this.sessionWidgetConfig.widget.configuration.widgetItemBackgroundColor;
            this.sessionWidgetConfig.widget.configuration.carouselArrowBoxColor = this.sessionWidgetConfig.widget.configuration.carouselArrowBoxColor;
            this.sessionWidgetConfig.widget.configuration.carouselArrowColor = this.sessionWidgetConfig.widget.configuration.carouselArrowColor;
            this.sessionWidgetConfig.widget.configuration.carouselDotsColor = this.sessionWidgetConfig.widget.configuration.carouselDotsColor;
            this.sessionWidgetConfig.widget.configuration.carouselDotsInactiveColor = this.sessionWidgetConfig.widget.configuration.carouselDotsInactiveColor;


             //Apply Widget Catalog Theme Configuration drawer configurations
             this.sessionWidgetConfig.widget.themeConfiguration.theme = this.sessionWidgetConfig.widget.themeConfiguration.theme;
             this.sessionWidgetConfig.widget.themeConfiguration.primary = this.sessionWidgetConfig.widget.themeConfiguration.primary;
             this.sessionWidgetConfig.widget.themeConfiguration.secondary = this.sessionWidgetConfig.widget.themeConfiguration.secondary;
             this.sessionWidgetConfig.widget.themeConfiguration.background = this.sessionWidgetConfig.widget.themeConfiguration.background;
             this.sessionWidgetConfig.widget.themeConfiguration.text = this.sessionWidgetConfig.widget.themeConfiguration.text;
             this.sessionWidgetConfig.widget.themeConfiguration.bodyText = this.sessionWidgetConfig.widget.themeConfiguration.bodyText;
             

            // Apply Widget text configuration
            this.sessionWidgetConfig.widget.text.title = this.sessionWidgetConfig.widget.text.title;
            this.sessionWidgetConfig.widget.text.addToSchedule = this.sessionWidgetConfig.widget.text.addToSchedule;
            this.sessionWidgetConfig.widget.text.recommendationDetails = this.sessionWidgetConfig.widget.text.recommendationDetails;
            this.sessionWidgetConfig.widget.text.similarSessions = this.sessionWidgetConfig.widget.text.similarSessions;
            this.sessionWidgetConfig.widget.text.recommendationsToReview = this.sessionWidgetConfig.widget.text.recommendationsToReview;
            this.sessionWidgetConfig.widget.text.recommendationsToReviewClick = this.sessionWidgetConfig.widget.text.recommendationsToReviewClick;
            this.sessionWidgetConfig.widget.text.replaceSchedule = this.sessionWidgetConfig.widget.text.replaceSchedule;
            this.sessionWidgetConfig.widget.text.overlapSchedule = this.sessionWidgetConfig.widget.text.overlapSchedule;
            this.sessionWidgetConfig.widget.text.waitlistSchedule = this.sessionWidgetConfig.widget.text.waitlistSchedule;
            this.sessionWidgetConfig.widget.text.similarSessionsButton = this.sessionWidgetConfig.widget.text.similarSessionsButton;
            this.sessionWidgetConfig.widget.text.similarSessionsTitle = this.sessionWidgetConfig.widget.text.similarSessionsTitle;
            this.sessionWidgetConfig.widget.text.recommendationDetails = this.sessionWidgetConfig.widget.text.recommendationDetails;
            this.sessionWidgetConfig.widget.text.popularSearchLabel = this.sessionWidgetConfig.widget.text.popularSearchLabel;
            this.sessionWidgetConfig.widget.text.confirmButton = this.sessionWidgetConfig.widget.text.confirmButton;
            this.sessionWidgetConfig.widget.text.cancelButton = this.sessionWidgetConfig.widget.text.cancelButton;
            this.sessionWidgetConfig.widget.text.myScheduleButton = this.sessionWidgetConfig.widget.text.myScheduleButton;
            this.sessionWidgetConfig.widget.text.myScheduleTitle = this.sessionWidgetConfig.widget.text.myScheduleTitle;
            this.sessionWidgetConfig.widget.text.myScheduleSubTitle = this.sessionWidgetConfig.widget.text.myScheduleSubTitle;
            this.sessionWidgetConfig.widget.text.myScheduleColumn = this.sessionWidgetConfig.widget.text.myScheduleColumn;
            this.sessionWidgetConfig.widget.text.myScheduleRecommendationColumn = this.sessionWidgetConfig.widget.text.myScheduleRecommendationColumn;
            this.sessionWidgetConfig.widget.text.myScheduleFillTheDayButton = this.sessionWidgetConfig.widget.text.myScheduleFillTheDayButton;
            this.sessionWidgetConfig.widget.text.myScheduleAvailableSessionsTitle = this.sessionWidgetConfig.widget.text.myScheduleAvailableSessionsTitle;

            this.prepareWidgetCatalogConfigurationStyle();
            this.changeWidgets(this.sessionWidgetConfig.widget.uuid);

            this.drawerService.hideDrawer();
        }
    }

    openConfigDrawer(item, $event, expansionStyle) {
        $event.stopPropagation();
        let url = "";
        this.sharedService.sessionLayoutConfig[this.baseUrl] = cloneDeep(this.sessionWidgetConfig);
        this.sharedService.expansionStyle = expansionStyle;
        this.sharedService.selectedSessionWidget = this.selectedWidget;
        if(item == 'configuration') {
            this.drawerService.toggleDrawer("small");
            this.sharedService.currentDrawer = {
                title: "Edit Theme Configuration",
                navLinks: [
                    new CclRouteTab("Display", "session/widget-config-page"),
                    new CclRouteTab("Labels", "session/widget-text-config-page")
                ],
                saveMessage: "apply-sessionwidgets-config"
            };
            url = "config-drawer/session/widget-config-page";
        }
        this.sharedService.navigateToOutlet("drawer", url);
    }

    toggleWidgetEnabled(ev) {
        this.sessionWidgetConfig.isWidgetEnabled = !this.sessionWidgetConfig.isWidgetEnabled;
        if(this.sessionWidgetConfig.isWidgetEnabled) {
            this.initLoadWidgetConfig();
        } else {
            this.loadWidgetsData();
        }
    }

    toggleApplyCatalogWidgetConfiguration(ev) {
        this.sessionWidgetConfig.widget.applyCatalogConfiguration = !this.sessionWidgetConfig.widget.applyCatalogConfiguration;

        if(!this.sessionWidgetConfig.widget.widgetPlacement) {
            this.sessionWidgetConfig.widget.widgetPlacement = 'html';
        }

        if(!this.sessionWidgetConfig.widget.widgetPlacementPosition) {
            this.sessionWidgetConfig.widget.widgetPlacementPosition = 'bottom';
        }

        if (!this.sessionWidgetConfig.widget.widgetPlacementComponentPosition) {
            this.sessionWidgetConfig.widget.widgetPlacementComponentPosition = {
                "top": null,
                "bottom": null
            };
        }

        this.loadWidgetPlacementComponents(this.sessionWidgetConfig.widget.widgetPlacement, false);

        this.loadSessionRecommendationWidgetSnippetPreview();
    }

    changeWidgets(widgetUUID) {
        if (this.widgets != null && this.widgets?.length > 0 && widgetUUID != null) {
            this.widgets.forEach((item) => {
                if (item.uuid == widgetUUID) {
                    this.selectedWidget = item;
                    this.sessionWidgetConfig.widget.uuid = item.uuid;
                    this.sessionWidgetConfig.widget.widgetConfiguration.color = item.widgetColorCustomization;
                    this.sessionWidgetConfig.widget.widgetConfiguration.theme = item.widgetThemeCustomization;
                    this.sessionWidgetConfig.widget.widgetConfiguration.labels = item.labels;
                    
                    this.retrieveSessionRecommendationWidgetsData();
                }
            });
        } else {
            this.selectedWidget = {};
            this.sessionWidgetConfig.widget.uuid = "";
            this.sessionWidgetConfig.widget.applyCatalogConfiguration = false;
            this.sessionWidgetConfig.widget.widgetConfiguration.color = null;
            this.sessionWidgetConfig.widget.widgetConfiguration.theme = null;
            this.sessionWidgetConfig.widget.widgetConfiguration.labels = null;
            this.isWidgetScrollable = false;

            this.retrieveSessionRecommendationWidgetsData();
        }
    }

    async retrieveSessionRecommendationWidgetsData() {
        if(!this.sharedService.isEmptyString(this.sessionWidgetConfig.widget.uuid) && this.sharedService.enableSessionWidgets) {
           await this.sessionWidgetService.getRecommendationWidgetSnippetPreview(
                this.sharedService.eventUUID, 
                this.sessionWidgetConfig.widget.uuid).subscribe((resp) => {
                this.widgetSnippet = resp.body;
                this.loadSessionRecommendationWidgetSnippetPreview();
            });

        } else {
            this.widgetSnippet = null;
            this.removeSessionRecommendationWidgetSnippet();
        }
    }

    getWidgetSnippet() {
        this.sessionWidgetService.getRecommendationWidgetSnippet(
            this.sharedService.eventUUID, 
            this.sessionWidgetConfig.widget.uuid).subscribe((resp) => {
            console.log("Selected Widget Snippet >>> " + resp.body);
            this.splitWidgetSnippetResponse(resp.body);
        });
    }

    getWidgetSnippetConfiguration() {
        this.sessionWidgetService.getRecommendationWidgetSnippetConfiguration(
            this.sharedService.eventUUID, 
            this.sessionWidgetConfig.widget.uuid).subscribe((resp) => {
            console.log("Selected Widget Snippet Configuration >>> " + resp.body);
        });
    }

    splitWidgetSnippetResponse(res) {

        // Extracting <div> content
        const divMatch = res.match(/<div[^>]*>(.*?)<\/div>/s);
        const divContent = divMatch ? divMatch[0] : "";

        // Extracting <script> content
        const scriptMatch = res.match(/<script[^>]*>(.*?)<\/script>/s);
        const scriptContent = scriptMatch ? scriptMatch[0] : "";

        // Extracting <style> content
        const styleMatch = res.match(/<style[^>]*>(.*?)<\/style>/s);
        const styleContent = styleMatch ? styleMatch[1].trim() : "";

        //Extracting token from response
        const tokenMatch = res.match(/data-session-recommendations-token="([^"]+)"/);
        const token = tokenMatch ? tokenMatch[1] : null;
    }

   async loadSessionRecommendationWidgetSnippetPreview() {
        if(this.widgetSnippet) {

            /** Remove already loaded widget snippet if selection changes by user */
           await this.removeSessionRecommendationWidgetSnippet();

            /** Start Widget initilization process and load script and stype within document */
            this.isWidgetScrollable = this.selectedWidget?.settings.widgetSection.scrolling;

            const script = document.createElement('script');
            script.id = "session-widget-script";
            script.src = this.widgetSnippet.scriptURL;
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);

            //Apply new style on ui component
            let widgetThemeEvent = null; 
            if(this.selectedWidget?.widgetThemeCustomization) {
                const themeConfig = (this.sessionWidgetConfig.widget.applyCatalogConfiguration ? 
                    this.sessionWidgetConfig.widget.themeConfiguration : 
                    this.sessionWidgetConfig.widget.widgetConfiguration.theme);

                widgetThemeEvent =  new CustomEvent('widget:notifyConfigurationChanged', {
                                            detail: 
                                                {message: 
                                                    {"themeChanged": {
                                                        "theme":themeConfig.theme,
                                                        "primary":themeConfig.primary,
                                                        "secondary":themeConfig.secondary,
                                                        "background":themeConfig.background,
                                                        "text":themeConfig.text,
                                                        "bodyText":themeConfig.bodyText
                                                        }
                                                    }
                                                }
                                            });
            } else {
                if((this.widgetSnippet.style && this.widgetSnippet.style != '') || this.sessionWidgetConfig.widget.applyCatalogConfiguration) {
                    const customizedStyle = document.createElement('style');
                    customizedStyle.id = 'session-widget-style';
                    if(this.sessionWidgetConfig.widget.applyCatalogConfiguration) {
                        customizedStyle.innerHTML = this.widgetCatalogConfiguredCssStyle;
                    } else {
                        customizedStyle.innerHTML = this.widgetSnippet.style;
                    }
                    document.body.appendChild(customizedStyle);
                }
            }

            const widgetContainer = document.getElementById("widgetPreview");
            // let initScript =
            window["_RecommendationsWidgetConfig_"] = {
                similarSessions: (this.selectedWidget?.settings ? this.selectedWidget.settings.widgetSection.similarSessions : true),
                token: this.widgetSnippet.token,
                preview: true,
                animation: (this.selectedWidget?.settings ? this.selectedWidget.settings.widgetSection.animation : "SLIDE_UP_FADE_IN"),
                text: (this.selectedWidget?.widgetThemeCustomization ? this.selectedWidget.labels : ((this.selectedWidget?.labels && !this.sessionWidgetConfig.widget.applyCatalogConfiguration) ? this.selectedWidget.labels : this.sessionWidgetConfig.widget.text)),
                widgetPlaceholderCallback: () => widgetContainer,
                mode: 'edit',
                widgetSection: {tiles: 3},
                test: true,
            };

            // When script is loaded, initialize the widget
            script.onload = () => {
                console.log('Session Widget script loaded to previw on catalog.');
                window['EAWidget'].init('rec-widget', window["_RecommendationsWidgetConfig_"]);
                window['CatalogRegistrationIdentifier'] = () => {}
            };

            /** STOP/COMPLETE Widget initilization process and load script and stype within document */
        }
    }

    async applyThemeConfigurations() {

            //Apply new style on ui component
            let widgetThemeEvent = null; 
            if(this.selectedWidget?.widgetThemeCustomization) {
                const themeConfig = (this.sessionWidgetConfig.widget.applyCatalogConfiguration ? 
                    this.sessionWidgetConfig.widget.themeConfiguration : 
                    this.sessionWidgetConfig.widget.widgetConfiguration.theme);

                widgetThemeEvent =  new CustomEvent('widget:notifyConfigurationChanged', {
                                            detail: 
                                                {message: 
                                                    {"themeChanged": {
                                                        "theme":themeConfig.theme,
                                                        "primary":themeConfig.primary,
                                                        "secondary":themeConfig.secondary,
                                                        "background":themeConfig.background,
                                                        "text":themeConfig.text,
                                                        "bodyText":themeConfig.bodyText
                                                        }
                                                    }
                                                }
                                            });



                // 2. Add a listener somewhere in your app
                // window.addEventListener("widget:notifyConfigurationChanged", (event: any) => {
                //     console.log("Theme event received:", event.detail.message);
                // });
            } 

            // When script is loaded, initialize the widget
                console.log('Session Widget script loaded to previw on catalog.');
                if(widgetThemeEvent) {
                    setTimeout(() => {
                        window.dispatchEvent(widgetThemeEvent);
                    }, 500);
                }
    }

    async removeSessionRecommendationWidgetSnippet() {
            /** Start Removal process */
            // Remove already existing widgets and their script url from main window
            const widgetsChildContainer = document.getElementById("widgetPreview_child_container");
            if(widgetsChildContainer) {
                while(widgetsChildContainer.firstChild) {
                    widgetsChildContainer.removeChild(widgetsChildContainer.firstChild);
                }
            }

            // Remove already available script from document
            const oldScript = document.getElementById("session-widget-script");
            if (oldScript) {
                oldScript.remove();
            }

            // Remove already available style from document
            const oldStyle = document.getElementById("session-widget-style");
            if (oldStyle) {
                oldStyle.remove();
            }

            //Remove already available window variables
            const windowVars = ['_RecommendationsWidgetConfig_', 'recommendationConfigurationCallback'];

            // this.processItems(windowVars);
            /** END Removal process */
    }

    async processItems(items: any[]) {
        for (const item of items) {
          await this.performRemovalTask(item);
        }
      }
      
      async performRemovalTask(item: string) {
        return new Promise((resolve) => {
        //   setTimeout(() => {
            if (item in window) {
                window[item] = {};
            }
            resolve(true);
        //   }, 0);
        });
      }

   async loadWidgetPlacementComponents(selectedComponent: string, isSwitch: Boolean) {
        if(selectedComponent == 'html') {
            var childrenCount = (this.htmlTopConfig?.isEnabled ? this.htmlTopConfig.template?.pages['landing']?.content.children.length : 0);
            console.log("HTML TOP PAGE INNER CHILDREN COUNT:  "+childrenCount);
            this.prepareWidgetPlacementComponentPositionData(childrenCount, isSwitch);

        } else if(selectedComponent == 'header') {
            var childrenCount = (this.headerConfig?.isEnabled ? this.headerConfig.template?.pages['landing']?.content.children.length : 0 );
            console.log("HEADER PAGE INNER CHILDREN COUNT:  "+childrenCount);
            this.prepareWidgetPlacementComponentPositionData(childrenCount, isSwitch);
        }
    }

    prepareWidgetPlacementComponentPositionData(count: number, isSwitch: Boolean) {
        this.widetPlacementComponents = [];
        if(isSwitch) {
            this.sessionWidgetConfig.widget.widgetPlacementComponentPosition = {
                "top": null, 
                "bottom": null
            };
        }

        if(count > 1) {
            for (let i = 1; i < count; i++) {
                const numLabel = i + 1;
                const item = {
                    id: numLabel.toString(),
                    label: this.getOrdinalNumberString(numLabel)
                };
                this.widetPlacementComponents.push(item);
            }
        } else {
            if(this.sessionWidgetConfig.widget.widgetPlacementPosition == "nth_component" || this.sessionWidgetConfig.widget.widgetPlacementPosition == "nth_component_bottom") {
                this.sessionWidgetConfig.widget.widgetPlacementPosition = "bottom";
            }
        }
    }

    private getOrdinalNumberString(pos: number): string {
        const numSuffix = ["th", "st", "nd", "rd"];
        const reminder = pos % 100;
        return pos + (numSuffix[(reminder - 20) % 10] || numSuffix[reminder] || numSuffix[0]);
    }

    manageWidgetPlacementPosition(selectedPosition: string) {
        this.sessionWidgetConfig.widget.widgetPlacementPosition = selectedPosition;
        if(this.sessionWidgetConfig.widget.widgetPlacementPosition != 'nth_component') {
            this.sessionWidgetConfig.widget.widgetPlacementComponentPosition.top = null;
        } 

        if(this.sessionWidgetConfig.widget.widgetPlacementPosition != 'nth_component_bottom') {
            this.sessionWidgetConfig.widget.widgetPlacementComponentPosition.bottom = null;
        }
    }

}
